import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { Sort } from "@angular/material/sort";
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Constants } from "../../../utils/constants";
import { Items } from "../../../model/items";
import { BillingItemsService } from "../../../services/billing-items.service";
import { ApiResponse } from 'src/app/classes/api-response';
import { SnackService } from "../../../services/snack.service";
import { DialogsService } from "../../../services/dialogs.service";
import { AuthService } from 'src/app/services/auth.service';
import { UpdateBillingDialogComponent } from '../update-billing-dialog/update-billing-dialog.component';
import { BillingSetupItemArray } from 'src/app/model/billingSetupItemArray';
import { BillingSetupService } from 'src/app/services/billing-setup.service';
import { BillingItems } from 'src/app/model/billingItems';

@Component({
  selector: 'aw-items',
  templateUrl: './items.component.html',
  styleUrls: ['./items.component.scss']
})
export class ItemsComponent {

  loadingGeneral = false;
  generalError?: ApiResponse;
  roles = Constants.roles;
  entities = Constants.entities;
  billingItems: Items[] = [];
  private allBillingSetup$!: Observable<BillingSetupItemArray[]>;

  range = new UntypedFormGroup({
    start: new UntypedFormControl(),
    end: new UntypedFormControl(),
  });

  headers = [
    'idSetup',
    'company',
    'contractDescription',
    'refContract',
    'contractBoxNumbers',
    'contractType',
    'startDate',
    'endDate',
    'action'
  ];

  @ViewChild('paginatorItems') paginatorUsers!: MatPaginator;
  // @ViewChild(MatSort)
  // sort!: MatSort;

  disabled = false;
  disabledItemId: number[] = [];
  dataSource!: MatTableDataSource<BillingItems>;
  panelOpenState = false;
  billingItemsById: BillingItems[] = [];
  contractTypes = Constants.contractTypes;
  loggedUser?: any;

  constructor(

    public dialog: MatDialog,
    private snackService: SnackService,
    private billingSetupService: BillingSetupService,
    private billingItemsService: BillingItemsService,
    private authService: AuthService) { }

  ngOnInit() {
    this.loggedUser = this.authService.loggedUser();
    if (this.loggedUser.role === this.roles.admin) {
      this.loadBillingItems();
    }
    else if (this.loggedUser.role === this.roles.customer) {
      this.loadBillingItemsByCompany();
    }


  }
  async getItemsById(billingSetupId: number | undefined): Promise<Array<BillingItems>> {
    return new Promise((resolve, reject) => {
      this.billingSetupService.getItemsById(
        billingSetupId
      )
        .subscribe(res => {
          this.billingItemsById = [];

          this.billingItemsById = res;
          const billingItemsById = this.billingItemsById
          if (billingItemsById != undefined) {
            this.billingItemsById = billingItemsById;
            resolve(this.billingItemsById);
            console.log('billingItemsById', this.billingItemsById);
          } else {
            reject('not a good response');
          }

        });
    })
  }

  async updateBillingSetup(billingSetupItemArray: BillingSetupItemArray) {
    this.disabled = false;

    if (billingSetupItemArray.id) {
      await this.getItemsById(billingSetupItemArray.id);
      billingSetupItemArray.billingItems = this.billingItemsById;

    }

    this.dialog
      .open(UpdateBillingDialogComponent,
        { data: { billingSetup: billingSetupItemArray }, panelClass: 'billing-dialog' })
      .afterClosed()
      .subscribe(
        () => {
          this.loadBillingItems();
        }
      );
  }

  deleteBillingSetup(billingSetup: Items): void {

    this.disabled = true;
    const id = billingSetup.id ?? -1;
    this.disabledItemId.push(id);

    this.billingItemsService.deleteBillingSetup(<number>billingSetup.id)
      .subscribe(() => {

        //  const index = this.dataSource.data.indexOf(id);
        this.dataSource.data.splice(id, 1);
        this.dataSource._updateChangeSubscription();

        this.disabled = false;
        this.snackService.success('Billing setup deleted!');
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);


      }, (error) => {
        this.snackService.error(error.message);
        this.disabled = false;
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
      },
        () => {
          this.disabled = false;
          this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
        });
    const index = this.dataSource.data.indexOf(billingSetup);
    this.dataSource.data.splice(index, 1);
    this.dataSource._updateChangeSubscription();


  }

  loadBillingItems(): void {
    this.billingItemsService.getAllBillingItems()

      .subscribe(res => {
        this.billingItems = res;
        if (this.billingItems)
          console.log('billingItems', res);
        this.dataSource = new MatTableDataSource(this.billingItems);

        this.dataSource.filterPredicate = (data: any, filter) => {
          //this.dataSource.filterPredicate = (data, filter) => JSON.stringify(data).includes(filter);
          const dataStr = data.id + data.contract.company.companyName + data.contract.description + data.identifier + data.contract.numberOfBoxes + data.contract.startDate + data.contract.endDate;
          return dataStr.trim().toLowerCase().indexOf(filter) != -1;
        }

        this.dataSource.paginator = this.paginatorUsers;
        this.loadingGeneral = false;
      });
  }

  loadBillingItemsByCompany(): void {
    this.billingItemsService.getAllBillingItemsByCompany(this.loggedUser.company.id)

      .subscribe(res => {
        this.billingItems = res;
        if (this.billingItems)
          console.log('billingItems', res);
        this.dataSource = new MatTableDataSource(this.billingItems);

        this.dataSource.filterPredicate = (data: any, filter) => {
          //this.dataSource.filterPredicate = (data, filter) => JSON.stringify(data).includes(filter);
          const dataStr = data.id + data.contract.company.companyName + data.contract.description + data.identifier + data.contract.numberOfBoxes + data.contract.startDate + data.contract.endDate;
          return dataStr.trim().toLowerCase().indexOf(filter) != -1;
        }

        this.dataSource.paginator = this.paginatorUsers;
        this.loadingGeneral = false;
      });
  }

  applyFilters(event: string): void {

    this.dataSource.filter = event.trim().toLowerCase();
  }

  doSortItems(event: Sort): void {
    this.dataSource.paginator?.firstPage();
    this.dataSource.data = this.dataSource.data.sort((a, b) => {

      if (event.active === 'idSetup') {
        if (event.direction === 'desc') {
          return b.id as number - (a.id ? a.id : 0);
        } else {
          return a.id as number - (b.id ? b.id : 0);
        }
      }

      if (event.active === 'company') {
        if (event.direction === 'desc') {
          return ('' + b.contract?.company?.companyName).localeCompare('' + a.contract?.company?.companyName);
        } else {
          return ('' + a.contract?.company?.companyName).localeCompare('' + b.contract?.company?.companyName);
        }
      }

      if (event.active === 'contractDescription') {
        if (event.direction === 'desc') {
          return ('' + b.contract?.description).localeCompare('' + a.contract?.description);
        } else {
          return ('' + a.contract?.description).localeCompare('' + b.contract?.description);
        }
      }

      if (event.active === 'refContract') {
        if (event.direction === 'desc') {
          return ('' + b.identifier).localeCompare('' + a.identifier);
        } else {
          return ('' + a.identifier).localeCompare('' + b.identifier);
        }
      }

      if (event.active === 'contractBoxNumbers') {
        if (event.direction === 'desc') {
          return ('' + b.contract?.numberOfBoxes).localeCompare('' + a.contract?.numberOfBoxes);
        } else {
          return ('' + a.contract?.numberOfBoxes).localeCompare('' + b.contract?.numberOfBoxes);
        }
      }

      if (event.active === 'contractType') {
        if (event.direction === 'asc') {
          return ('' + b.contract?.thirdPartyContract).localeCompare('' + a.contract?.thirdPartyContract);
        } else {
          return ('' + a.contract?.thirdPartyContract).localeCompare('' + b.contract?.thirdPartyContract);
        }
      }

      if (event.active === 'startDate') {
        if (event.direction === 'desc') {
          return ('' + b.contract?.startDate).localeCompare('' + a.contract?.startDate);
        } else {
          return ('' + a.contract?.startDate).localeCompare('' + b.contract?.startDate);
        }
      }

      if (event.active === 'endDate') {
        if (event.direction === 'desc') {
          return ('' + b.contract?.endDate).localeCompare('' + a.contract?.endDate);
        } else {
          return ('' + a.contract?.endDate).localeCompare('' + b.contract?.endDate);
        }
      }

      return -1;


    }
    );
  }
}